import React from 'react';
import logoDark from '@assets/img/light-logo.svg';

const LogoDark = () => (
  <img src={logoDark} alt="Logo Light" />
);

export default LogoDark;
